import { useState } from "react";

import Image from "next/image";
import { useRouter } from "next/router";

import { useOrganizationConfig } from "shared/hooks/useOrganizationConfig";
import { ISubscribedOrg } from "shared/providers/context/types/auth-context";
import useMainPage from "shared/utils/hooks/useMainPage";

import { ConsolePageForm } from "@Console/components/molecules/ConsolePageForm";

import { FallbackImage, OrganizationContainer } from "./styles";

interface IOrganizationProps {
  org: ISubscribedOrg & {
    fallbackBackgroundColor?: string;
  };
}

export const Organization = ({ org }: IOrganizationProps) => {
  const [loadImageFailed, setLoadImageFailed] = useState(false);
  const { saveOrganizationInCookies, setIsChangingOrganization } =
    useOrganizationConfig();
  const { push, asPath, reload } = useRouter();
  const mainPage = useMainPage();
  const alreadyInMainPage =
    asPath?.includes("/browse") || asPath?.includes("/dashboard");

  const handleOrganizationClick = (organization: ISubscribedOrg) => {
    saveOrganizationInCookies(organization);
    setIsChangingOrganization(true);

    if (alreadyInMainPage) reload();
    else push(`/${mainPage}`);
  };

  const shouldShowOrgImage = !loadImageFailed && !!org?.main_image;

  return (
    <OrganizationContainer isMain={org?.id === 0}>
      {shouldShowOrgImage ? (
        <Image
          key={org?.main_image}
          src={org?.main_image}
          alt={org?.title}
          width={230}
          height={132}
          quality={90}
          onError={() => setLoadImageFailed(true)}
        />
      ) : (
        <FallbackImage
          width={230}
          height={132}
          backgroundColor={org?.fallbackBackgroundColor}
        />
      )}

      <div className="texts">
        <span>{org?.title}</span>
        <p>{org?.description}</p>
      </div>

      <ConsolePageForm.Button
        id={`go-to-org-${org?.id}-button`}
        variant="primary"
        onClick={() => handleOrganizationClick(org)}
      >
        Entrar
      </ConsolePageForm.Button>
    </OrganizationContainer>
  );
};
